import React from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import { useLocation } from "react-router";
import ComponentModalLayout from "./ComponentModalLayout";
import PATH from "../config/PATH";
import { curStateAccount, curStateHome } from "../Redux/selector";
import { setPU4NeverShow } from "../Redux/futures/account/actions";
import { setReduxDataTypeIntroTour } from "../Redux/futures/home/actions";
import { KEY_LOCAL_TYPE_USER, TYPE_USER } from "../helper/const";
import {
  dismissTourInvite,
  isTourInviteDue,
  setNeverShowTourInvite,
} from "../utils/introTour";

// ─────────────────────────────────────────────────────────────────────────────
// Popup mời bắt đầu tour hướng dẫn — LUỒNG DÀNH CHO NGƯỜI MỚI.
//
// Trước đây là pu4 trong popup manager. Nay tách riêng: không có trong
// popupRules/popupRegistry và không tính vào giới hạn của popup manager. Popup
// manager chỉ nhường màn hình khi luồng này đang hoạt động (isNewUserFlowActive).
//
// Chỉ hiện ở Home — các bước tour đều nằm ở Home. Điều kiện hiển thị và tần suất:
// isTourInviteDue (utils/introTour.js).
//
// Nút trong ModalUserFlowCases:
//   - "Bắt đầu"          → step 1 (tour chạy), rồi gọi onClose
//   - X / "Bỏ qua"       → onNeverShow (ModalUserFlowCases đã ghi tourComplete)
//   - chạm ra ngoài      → onClose — mời lại sau 7 ngày
// ─────────────────────────────────────────────────────────────────────────────
export default function NewUserTourInvite() {
  const dispatch = useDispatch();
  const store = useStore();
  const userInfo = useSelector(curStateAccount).userInfo;
  const { typeIntroTour } = useSelector(curStateHome);
  const { pathname } = useLocation();

  if (pathname !== PATH.HOME) return null;
  if (!isTourInviteDue({ typeIntroTour, userInfo })) return null;

  const userId = userInfo.id;

  const handleClose = () => {
    // "Bắt đầu" cũng gọi onClose ngay sau khi đã chuyển sang step 1 — đọc state
    // mới nhất từ store, đừng dùng typeIntroTour của lần render này (vẫn là step 0)
    // kẻo ghi đè tour vừa bắt đầu về lại màn mời.
    const latest = store.getState().reducerHome.typeIntroTour;
    if (+latest?.step !== 0) return;

    dismissTourInvite(userId);
    // Dispatch để mọi nơi đọc typeIntroTour render lại — popup manager cần biết
    // luồng người mới đã nhường màn hình. typeActive/step giữ nguyên: đóng popup
    // KHÔNG có nghĩa là đã xong tour.
    dispatch(setReduxDataTypeIntroTour({ ...latest, inviteDismissedAt: Date.now() }));
  };

  const handleNeverShow = () => {
    // Ghi server để theo user qua nhiều thiết bị (WEB_USER.is_intro_dismissed)...
    dispatch(setPU4NeverShow({}));
    // ...và localStorage để có tác dụng ngay, không đợi lần /current kế tiếp.
    setNeverShowTourInvite(userId);
    localStorage.removeItem(KEY_LOCAL_TYPE_USER);
    dispatch(setReduxDataTypeIntroTour({ typeActive: TYPE_USER.general, step: -1 }));
  };

  return <ComponentModalLayout onClose={handleClose} onNeverShow={handleNeverShow} />;
}
